import JwtDecode from 'jwt-decode'
import axios from '../api/vue-axios/axios'

export default class User {
  static fromToken (token) {
    let obj = JwtDecode(token)

    return axios.get('/users/' + obj.user_id)
      .then(request => {
        return new User(request.data.user)
      })
      .catch(request => {
        return Promise.reject(request)
      })
  }

  static fromObject (userObject) {
    return new User(userObject)
  }

  fullName () {
    return this.firstName + ' ' + this.lastName
  }

  hometown () {
    let str = ''
    if (this.city) str += this.city
    if (this.city && this.state) str += ', '
    if (this.state) str += this.state
    return str
  }

  personalUrlLink () {
    return 'http://' + this.personalUrl
  }


  constructor (user) {
    this.id                 = user.id
    this.emailAddress       = user.email_address
    this.firstName          = user.first_name
    this.lastName           = user.last_name
    this.personalUrl        = user.personal_url
    this.city               = user.city
    this.state              = user.state
    this.profession         = user.profession
    this.hasAvatar          = user.has_avatar
    this.avatar             = user.avatar
    this.avatarMidsize      = user.avatar_midsize
    this.avatarThumbnail    = user.avatar_thumbnail
    this.paypalEmailAddress = user.paypal_email_address
    this.referralCode       = user.referral_code
    this.addressLineOne     = user.address_line_one
    this.addressLineTwo     = user.address_line_two
    this.zipCode            = user.zip_code
    this.identifier         = user.identifier
    this.bio                = user.bio
    this.createdAt          = user.created_at
  }
}



// WEBPACK FOOTER //
// ./src/models/User.js